import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validator } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { VentayaService } from '../../services/ventaya.service';

@Component({
  selector: 'app-ventaya',
  templateUrl: './ventaya.component.html',
  styleUrls: ['./ventaya.component.scss']
})
export class VentayaComponent implements OnInit {

  formulario: FormGroup
  posts: any[] = []

  constructor(private formBuilder: FormBuilder,
    private ventayaService: VentayaService) {

  }

  ngOnInit() {
    this.getAllPost()
    this.formulario = this.formBuilder.group({
      id_categoria: [1],
      titulo: "",
    })

  }
  async setState(id) {
    showSpinner()
    const result = await this.ventayaService.setState(id[0]['id'])
    this.getAllPost()
    hideSpinner()
  }
  async getAllPost() {
    showSpinner()
    const result = await this.ventayaService.getPost()
    if (result.success) {
      this.posts = result.data
    }
    hideSpinner()
  }

  create() {
    showSpinner()
    const result = this.ventayaService.create(JSON.stringify(this.formulario.value))
    this.formulario.reset()
    console.log(result)
    hideSpinner()
    this.getAllPost()
    this.formulario = this.formBuilder.group({
      id_categoria: [1],
      titulo: "",
      url: "",
      descripcion: "",
      estado: "ON"
    })
    this.getAllPost()
    this.formulario.reset()
  }

}